"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exitFullScreen = void 0;

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

/**
 * will exit full screen mode
 *
 * @param {function} will be called with false parameter when full screen mode is exited
 */
var exitFullScreen = function exitFullScreen(setIsFullScreen) {
  if (document.fullscreenElement) {
    document.exitFullscreen();
    document.dispatchEvent(new Event("trc-fullscreen-exit"));
    if (typeof setIsFullScreen === 'function') setIsFullScreen(false);
  } else if (document.webkitCurrentFullScreenElement) {
    document.webkitExitFullscreen();
    document.dispatchEvent(new Event("trc-fullscreen-exit"));
    if (typeof setIsFullScreen === 'function') setIsFullScreen(false);
  }
};

exports.exitFullScreen = exitFullScreen;